import { render } from "./EarLobeRepairContentEs.vue?vue&type=template&id=f1c6b4dc"
import script from "./EarLobeRepairContentEs.vue?vue&type=script&lang=js"
export * from "./EarLobeRepairContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__